import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Fire, ArrowRight, Check } from "@phosphor-icons/react";

export default function PromoteEventModal({ open, onOpenChange, event }) {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState("boost_14");

  useEffect(() => {
    if (open) {
      api.get("/payments/packages").then(({ data }) => setPackages(data.packages)).catch(() => {});
    }
  }, [open]);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        event_id: event.event_id,
        package_id: selected,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore checkout");
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border rounded-sm max-w-2xl" data-testid="promote-modal">
        <DialogHeader>
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-primary mb-2 flex items-center gap-2">
            <Fire size={12} weight="fill" /> Boost
          </div>
          <DialogTitle className="font-display text-3xl font-black uppercase tracking-tighter">Metti in evidenza il tuo evento</DialogTitle>
          <p className="text-neutral-400 text-sm mt-2">Il tuo evento sarà in cima ai risultati e nella homepage per il periodo scelto.</p>
        </DialogHeader>

        <div className="grid sm:grid-cols-3 gap-3 mt-4">
          {packages.map(p => {
            const isSelected = selected === p.id;
            const isRecommended = p.id === "boost_14";
            return (
              <button
                key={p.id}
                onClick={() => setSelected(p.id)}
                data-testid={`package-${p.id}`}
                className={`relative text-left p-5 border rounded-sm transition-colors ${isSelected ? "border-primary bg-primary/5" : "border-border hover:border-primary/40"}`}
              >
                {isRecommended && (
                  <span className="absolute -top-2 left-3 px-2 py-0.5 bg-primary text-white text-[9px] font-black uppercase tracking-widest">Consigliato</span>
                )}
                {isSelected && (
                  <div className="absolute top-3 right-3 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                    <Check size={12} weight="bold" className="text-white" />
                  </div>
                )}
                <div className="text-xs font-bold uppercase tracking-widest text-neutral-400 mb-2">{p.days} giorni</div>
                <div className="font-display text-3xl font-black tracking-tighter">€{p.amount.toFixed(0)}</div>
                <div className="text-[10px] text-neutral-500 mt-1">Featured slot</div>
              </button>
            );
          })}
        </div>

        <div className="mt-6 p-4 border border-white/5 rounded-sm bg-black/30">
          <div className="text-[10px] font-bold uppercase tracking-widest text-neutral-500 mb-3">Cosa ottieni</div>
          <ul className="text-sm text-neutral-300 space-y-2">
            <li className="flex items-center gap-2"><Check size={14} weight="bold" className="text-primary" /> Primo posto nei risultati di ricerca</li>
            <li className="flex items-center gap-2"><Check size={14} weight="bold" className="text-primary" /> Badge "FEATURED" ben visibile</li>
            <li className="flex items-center gap-2"><Check size={14} weight="bold" className="text-primary" /> Marker più grande sulla mappa</li>
            <li className="flex items-center gap-2"><Check size={14} weight="bold" className="text-primary" /> Slot nella homepage "In evidenza"</li>
          </ul>
        </div>

        <div className="text-[10px] text-neutral-500 mt-4">
          Pagamento sicuro con Stripe. Test card: 4242 4242 4242 4242
        </div>

        <Button
          onClick={handleCheckout}
          disabled={loading}
          data-testid="promote-checkout-btn"
          className="w-full h-14 bg-primary hover:bg-primary/90 text-white font-black uppercase tracking-wider rounded-sm mt-2"
        >
          {loading ? "Reindirizzamento..." : <>Paga e promuovi <ArrowRight size={16} weight="bold" className="ml-2" /></>}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
